import { gql } from 'graphql-request'
import { useQuery, UseQueryOptions } from '@/proxy/react-query'
import { client } from '@/proxy/client'

export const SHORTCUT_INVENTORY_ITEMS = gql`
  query sellerShortcutInventoryItems(
    $pagination: PaginationInput!
    $filters: InventoryItemFilterInput
  ) {
    inventoryItems(pagination: $pagination, filters: $filters) {
      product {
        id
        name
        category {
          id
          name
          order
        }
        variants {
          id
          name
          imageUrl
          group {
            id
            name
          }
        }
      }
      isAvailable
    }
  }
`

export const SHORTCUT_INVENTORY_ITEMS_KEY = 'useShortcutInventoryItems'

export interface ShortcutInventoryItem {
  product?: {
    id: number
    name?: string
    category?: { id: number; name: string; order: number }
    variants?: Array<{
      id: number
      name?: string
      imageUrl?: string
      group?: { id: number; name: string }
    }>
  }
  isAvailable?: boolean
}

export interface ShortcutInventoryItemsResponse {
  inventoryItems?: ShortcutInventoryItem[]
  error?: string
}

type ShortcutInventoryItemsVariables = {
  pagination: { page: number; perPage: number }
  filters?: { variantIds?: number[] }
}

type UseShortcutInventoryItemsOptions = Omit<
  UseQueryOptions<ShortcutInventoryItemsResponse>,
  'queryKey' | 'queryFn'
>

export const useShortcutInventoryItems = (
  variables: ShortcutInventoryItemsVariables,
  options?: UseShortcutInventoryItemsOptions
) =>
  useQuery<ShortcutInventoryItemsResponse>({
    queryKey: [SHORTCUT_INVENTORY_ITEMS_KEY, variables],
    queryFn: () =>
      client.request<ShortcutInventoryItemsResponse>(
        SHORTCUT_INVENTORY_ITEMS,
        variables
      ),
    ...options,
  })
